module.exports = __webpack_public_path__ + "9f2699e01a923b461aff8537f3c769a8.png";